import * as React from 'react';

import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { type Row } from '@process-advisor/process-miner/api/methods/filters/setStepFilterSelectedGridData';
import { DataGrid } from '@process-advisor/process-miner/filters/activities/dataGrid';
import { activityGridColumns } from '@process-advisor/process-miner/filters/activities/activityGridColumns';
import { Event } from '@process-advisor/process-miner/api/events';
import { type ColDef, themeAlpine } from 'ag-grid-community';
import '@process-advisor/process-miner/shared/gridStyles.css'

type Props = {
    setApplyEnabled: (value: boolean) => void;
    selectionMode: string;

};

export const ActivitiesGrid: React.FC<Props> = ({ setApplyEnabled , selectionMode}) => {
    const [rows, setRows] = React.useState([]);
    const [columns, setColumns] = React.useState<ColDef[]>();

    React.useEffect(() => {
        setRows(apiProvider.processActivitiesTable());
        setColumns(activityGridColumns())
    }, []);

    React.useEffect(() => {
        const listener = () => {
            apiProvider.changeIncludeStart({includeStart: false});
            setRows(apiProvider.processActivitiesTable());
        };

        apiProvider.on(Event.applyFilter, listener);
        apiProvider.on(Event.resetFilter, listener);
        return () => {
            apiProvider.off(Event.applyFilter, listener);
            apiProvider.off(Event.resetFilter, listener);
        };
    }, []);

    return (
        <DataGrid
            rows={rows}
            columns={columns}
            setApplyEnabled={setApplyEnabled}
            selectionMode={selectionMode}
            height="300px" />
    );
};
